import type { GlobalSettings } from '../globalSettings';

export type WaymarkSettings = {
  'waymark.csrfCookieName': string;
  'waymark.env': 'local' | 'dev' | 'prod';
};

export const applyDefaultWaymarkSettings = (settings: GlobalSettings<WaymarkSettings>) =>
  settings.set('waymark.csrfCookieName', 'csrftoken').set('waymark.env', 'prod');
